import { inject } from '@angular/core';
import { type CanActivateFn } from '@angular/router';
import { NEVER, type Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { StudentCabinetService } from '../../../../student-cabinet/shared/service/student-cabinet-service';

/** Адрес той же страницы в кабинете Singularity: путь, query и hash сохраняются целиком. */
export function getSingularityCabinetUrl(url: string, rootDomain: string): string {
  return `https://my-singularity.${rootDomain}${url}`;
}

/**
 * Кабинет учеников Singularity переехал в приложение public-singularity (SINGULAR-4510).
 * Ученика Singularity (хотя бы один поток СПО, ВО, ДО или с назначением SingularityHub —
 * `isSingularityCabinetStudent$`) уводим туда полной навигацией браузера, включая смешанных с ДПО. Редирект только с боевого хоста `my.<rootDomain>`: локальная сборка
 * не уходит на чужой хост. Ошибка загрузки пользователя страницу не блокирует — решают остальные гарды.
 */
export const singularityCabinetRedirectGuard: CanActivateFn = (_route, state): Observable<boolean> => {
  const { rootDomain } = environment.app;

  if (window.location.hostname !== `my.${rootDomain}`) {
    return of(true);
  }

  return inject(StudentCabinetService).isSingularityCabinetStudent$.pipe(
    switchMap(isSingularityCabinetStudent => {
      if (!isSingularityCabinetStudent) {
        return of(true);
      }

      window.location.replace(getSingularityCabinetUrl(state.url, rootDomain));

      return NEVER;
    }),
    catchError(() => of(true)),
  );
};
